import React from 'react';

class PlanItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSubscriptionTitle = (action, userSubscription) => {
    switch (userSubscription.interval) {
      // case 'Monthly':
      //   return 'Monthly Subscription';
      case 'SemiAnnually':
        return userSubscription?.isOccupational
          ? 'Semi-Annual Subscription (PFE+SKT)'
          : 'Semi-Annual Subscription (PFE Only)';

      case 'Annually':
        return userSubscription?.isOccupational
          ? 'Annual Subscription (PFE+SKT)'
          : 'Annual Subscription (PFE Only)';

      default:
        return '';
    }
  };

  getSubscriptionFromPlans = (user) => {
    const isPfeOnly = user.rate.isPfeOnly;

    let selectedPlan = this.props.plans[0];

    if (isPfeOnly) {
      if (
        this.props.plans[1] &&
        this.props.plans[1].amount < selectedPlan.amount
      ) {
        selectedPlan = this.props.plans[1];
      }
    } else {
      if (
        this.props.plans[1] &&
        this.props.plans[1].amount > selectedPlan.amount
      ) {
        selectedPlan = this.props.plans[1];
      }
    }

    return (selectedPlan.amount / 100).toFixed(2);
  };

  getSubscriptionAmount = (action, userSubscription, user) => {
    if (action === 'UPGRADE' || action === 'CHANGE' || action === 'RENEW') {
      return this.getSubscriptionFromPlans(user);
    }

    if (action === 'REVERT-CANCELLATION' || action === 'DEFAULT') {
      return userSubscription.amount;
    }
  };

  getBillingInterval = (action, userSubscription) => {
    switch (userSubscription.interval) {
      case 'Monthly':
        return 'per month (plus tax)';
      case 'SemiAnnually':
        return 'per 6 months (plus tax)';
      case 'Annually':
        return 'per year (plus tax)';
      default:
        return '';
    }
  };

  render() {
    const action = this.props.action;
    const userSubscription = this.props.userSubscription;
    const user = this.props.user;
    const plans = this.props.plans;

    if (!action || plans.length < 2) {
      return null;
    }
    return (
      <div className="plan-item">
        <div className="plan-item-contents">
          <div className="plan-item-header">
            <div className="title">
              {userSubscription.warfarePlan
                ? 'Warfare & Qualifications Only Subscription'
                : this.getSubscriptionTitle(action, userSubscription)}
            </div>
            <div className="pricing-box">
              <div className="price">
                ${this.getSubscriptionAmount(action, userSubscription, user)}
              </div>
              <div className="price-description">
                {this.getBillingInterval(action, userSubscription)}
              </div>
            </div>
          </div>
          <div className="plan-item-description">
            {/* Access to study material and functions of quals and certs. Cancel
            anytime. */}
            {userSubscription.isOccupational
              ? 'Full access to all PFE and SKT study material and features. Cancel anytime.'
              : 'Full access to all PFE study material and features. Cancel anytime.'}
          </div>
        </div>
      </div>
    );
  }
}

export default PlanItem;
